import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEFAULT_GAME_ID, getGameById, type GameConfig, type FeatureKey } from '@/config/games';

interface GameState {
  /** Identifiant du jeu actuellement sélectionné. */
  activeGameId: string;
  /** Change le jeu actif. */
  setActiveGame: (id: string) => void;
  /** Config complète du jeu actif. */
  getActiveGame: () => GameConfig;
  /** Le jeu actif supporte-t-il cette fonctionnalité ? */
  hasFeature: (feature: FeatureKey) => boolean;
}

export const useGameStore = create<GameState>()(
  persist(
    (set, get) => ({
      activeGameId: DEFAULT_GAME_ID,

      setActiveGame: (id) => set({ activeGameId: id }),

      getActiveGame: () => getGameById(get().activeGameId),

      hasFeature: (feature) => getGameById(get().activeGameId).features.includes(feature),
    }),
    {
      name: 'recubebe-game',
      partialize: (state) => ({ activeGameId: state.activeGameId }),
    }
  )
);
